<template>
  <v-container class="h-100" grid-list-lg>
    <v-layout  class="h-100" align-center row wrap>
      <v-flex xs6>
        <v-flex xs12 class="drag-container" :class="dragAreaClass">
          <vue-perfect-scrollbar>
            <v-flex xs12 class="drag-area">
              <draggable
                class="droppable-area"
                v-model="items"
                :class="dragAreaClass"
                :group="allItems"
                @start="start"
                @end="end">
                <div class="d-inline-block draggable-block" v-for="field in items" :key="field.id">
                  <v-chip class="btn-draggable" :disabled="true">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 512" class="svg-inline--fa fa-grip-vertical fa-w-10"><path fill="currentColor" d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z M204 208c26.5 0 48 21.5 48 48s-21.5 48 -48 48 -48 -21.5 -48 -48 21.5 -48 48 -48zM156 104c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48zm0 304c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48z" class=""></path></svg>
                    {{ field.text }}
                  </v-chip>
                </div>
              </draggable>
            </v-flex>      
          </vue-perfect-scrollbar>
        </v-flex>
      </v-flex>
      <v-flex xs6>
        <v-flex xs12 class="drag-container" :class="dragAreaClass">
          <vue-perfect-scrollbar>
            <v-flex xs6 class="drag-area">
              <draggable
                class="droppable-area"
                v-model="activeItems"
                :class="dragAreaClass"
                :group="activeChannels"
                @start="start"
                @end="end">
                <div class="d-flex draggable-block" v-for="(field, i) in activeItems" :key="`template-chip-active${i}`">
                  <v-chip class="btn-draggable" :disabled="true">
                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 512" class="svg-inline--fa fa-grip-vertical fa-w-10"><path fill="currentColor" d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z M204 208c26.5 0 48 21.5 48 48s-21.5 48 -48 48 -48 -21.5 -48 -48 21.5 -48 48 -48zM156 104c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48zm0 304c0 26.5 21.5 48 48 48s48 -21.5 48 -48 -21.5 -48 -48 -48 -48 21.5 -48 48z" class=""></path></svg>
                    {{ field.text }}
                  </v-chip>
                  <template v-if="(i+1) < activeItems.length">
                    <v-menu offset-y >
                      <template slot="activator">
                        <v-chip >
                          {{ field.conector === 'AND' ? 'Y' : 'O' }}
                        </v-chip>
                      </template>
                      <v-list>
                        <v-list-tile @click="setConector('AND', i)">
                          <v-list-tile-title >Y</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="setConector('OR', i)">
                          <v-list-tile-title >O</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </template>
                </div>
              </draggable>
            </v-flex>      
          </vue-perfect-scrollbar>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Draggable from 'vuedraggable';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    Draggable,
    VuePerfectScrollbar,
  },
  data() {
    return {
      dragging: false,
      items: [
        {
          text: 'Teléfono local',
          conector: 'AND',
        },
        {
          text: 'Email',
          conector: 'AND',
        },
      ],
      activeItems: [
        {
          text: 'Teléfono celular',
          conector: 'AND',
        },
      ],
      allItems: {
        name: 'allItems',
        pull: ['activeChannels', 'allItems'],
        put: ['activeChannels', 'allItems'],
      },
      activeChannels: {
        name: 'activeChannels',
        pull: ['allItems', 'activeChannels'],
        put: ['allItems', 'activeChannels'],
      },
    };
  },
  computed: {
    dragAreaClass() {
      return this.dragging ? 'drag-area-highlight' : null;
    },
  },
  methods: {
    setConector(type, key) {
      this.activeItems[key].conector = type;
    },
    addConector() {
      const number = this.activeItems.length;
      this.$set(this.activeItems, (number - 1), { ...this.activeItems[(number - 1)], conector: 'AND' });
    },
    start() {
      this.dragging = true;
    },
    end() {
      this.dragging = false;
    },
  },
  watch: {
    activeItems: {
      deep: true,
      handler() {
        this.$emit('change', this.activeItems);
      },
    },
  },
};
</script>
<style scoped>
  /* Drag & drop stuff */
  .drag-container {
    border: 1px dashed #ccc;
  }
  .drag-area {
    height: 150px;
    max-height: 150px;
    padding: 0.5rem;
    transition: background-color 0.4s;
  }
  .drag-area .droppable-area {
    min-height: 100%;
  }
  .drag-area .draggable-block .chip >>> .chip__content {
    cursor: move !important;
  }

  .drag-area-highlight {
    background-color: #f3f3f3;
  }

  .drag-area-label {
    position: absolute;
    padding: 0.75rem 1rem;
  }

  .sortable-ghost {
    opacity: 0.4;
  }
  /* Handle icon (mix of grip-vertical & ellipsis-v) */
  .svg-inline--fa.fa-w-10 {
    width: 0.625em;
  }

  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -.125em;
  }

  .btn-draggable .fa-grip-vertical {
    margin-left: -0.375rem;
    margin-right: 0.375rem;
  }
  /* Draggable buttons */
  .btn-draggable {
    white-space: normal;
    text-align: left;
  }
  .bordered-all-2 {
    border: 2px solid #d3d3d3;
  }
  .border-rounded {
    border-radius: 6px;
  }
  .bordered-bottom {
    border-bottom: 1px solid #d3d3d3;
    border-collapse: collapse;
  }
</style>





// WEBPACK FOOTER //
// src/components/panelV2/Contactability/Channels.vue